export const criteriaKeys = {
  all: ['criteria'] as const,
  lists: () => [...criteriaKeys.all, 'list'] as const,
  list: (applicationId: string, perspectiveId?: string) =>
    [...criteriaKeys.lists(), applicationId, perspectiveId ?? null] as const,
} as const;

export const perspectiveKeys = {
  all: ['perspectives'] as const,
  lists: () => [...perspectiveKeys.all, 'list'] as const,
  list: () => [...perspectiveKeys.lists()] as const,
} as const;
